import React from 'react'
import { IonSpinner, IonText, IonChip, IonIcon } from '@ionic/react'
import { checkmarkCircleOutline } from 'ionicons/icons'
import { useBackgroundSync } from '../../providers/BackgroundSync'
import { formatDistanceToNow } from 'date-fns'
import { de } from 'date-fns/locale'
import './style.scss'

const BackgroundSyncIndicator: React.FC = () => {
  const { isLoading, lastSyncTime } = useBackgroundSync()

  if (!isLoading && !lastSyncTime) {
    return null
  }

  return (
    <div className="background-sync-indicator">
      {isLoading
        ? (
        <IonChip color="primary" outline>
          <IonSpinner name="dots" />
          <IonText className="sync-text">Daten werden synchronisiert...</IonText>
        </IonChip>
          )
        : lastSyncTime
          ? (
        <IonChip color="success" outline>
          <IonIcon icon={checkmarkCircleOutline} />
          <IonText className="sync-text">
            Zuletzt aktualisiert {formatDistanceToNow(lastSyncTime, { locale: de, addSuffix: true })}
          </IonText>
        </IonChip>
            )
          : null}
    </div>
  )
}

export default BackgroundSyncIndicator
